<template>
  <div :class="$style.frameParent">
    <div :class="$style.frameGroup">
      <h2>{{ title }}</h2>
      <div :class="$style.frameContainer">
        <div :class="$style.flexGroup" :style="$global.dynamicCols(2)">
          <div :class="$style.formGroup">
            <div>FAA DPE Number</div>
            <input
              type="number"
              v-model="form.faaNumber"
              placeholder="Type your hours..."
            />
          </div>
          <div :class="$style.formGroup">
            <div>Expiration Date</div>
            <input
              type="date"
              v-model="form.expirationDate"
              placeholder="Choose date..."
            />
          </div>
        </div>

        <div :class="$style.formGroup">
          <div>FAA region assigned</div>
          <input
            type="text"
            v-model="form.faaRegion"
            placeholder="Type your answer..."
          />
        </div>

        <div :class="$style.formGroup">
          <div>Type of designation</div>
          <HiloSelect
            :theme="'grey'"
            v-model="form.designation"
            :options="[
              { id: true, name: 'Yes' },
              { id: false, name: 'No' },
            ]"
            :placeholder="'Select all that apply...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>

        <div :class="$style.formGroup">
          <div>Certifications and ratings currently held</div>
          <HiloSelect
            :theme="'grey'"
            v-model="form.certifications"
            :options="[
              { id: true, name: 'Yes' },
              { id: false, name: 'No' },
            ]"
            :placeholder="'Select all that apply...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>

        <div :class="$style.formGroup">
          <div>Total flight hours</div>
          <input
            type="text"
            v-model="form.flightHours"
            placeholder="Type your answer..."
          />
        </div>

        <div :class="$style.formGroup">
          <div>Number of checkrides willing to conduct monthly</div>
          <input
            type="text"
            v-model="form.checkrides"
            placeholder="Type your answer..."
          />
        </div>

        <div :class="$style.formGroup">
          <div>
            What type of aircraft are you authorized to conduct checkrides on?
            (Check all that apply):
          </div>
          <input
            type="text"
            v-model="form.aircraftCheckrides"
            placeholder="Type your answer..."
          />
        </div>

        <div :class="$style.formGroup">
          <div>
            What areas are you willing to travel to for checkrides? (List states
            or regions)
          </div>
          <input
            type="text"
            v-model="form.travelCheckrides"
            placeholder="Type your answer..."
          />
        </div>

        <div :class="$style.formGroup">
          <div>
            Would you like to connect with local flights for checkride
            assignments?
          </div>
          <HiloSelect
            :theme="'grey'"
            v-model="form.localCheckrides"
            :options="[
              { id: true, name: 'Yes' },
              { id: false, name: 'No' },
            ]"
            :placeholder="'Choose one...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>

        <div :class="$style.spaceBetween">
          <div :class="$style.formGroup">
            <div>Upload a copy of your FAA DPE Certificate.</div>
          </div>
          <div :class="$style.formGroup">
            <button :class="$style.uploadBtn">Upload</button>
          </div>
        </div>

        <div :class="$style.spaceBetween">
          <div :class="$style.formGroup">
            <div>Upload a copy of your valid Pilot Certificate.</div>
          </div>
          <div :class="$style.formGroup">
            <button :class="$style.uploadBtn">Upload</button>
          </div>
        </div>

        <div :class="$style.spaceBetween">
          <div :class="$style.formGroup">
            <div>
              Upload a copy of your valid Driver's License or Government-issued
              ID.
            </div>
          </div>
          <div :class="$style.formGroup">
            <button :class="$style.uploadBtn">Upload</button>
          </div>
        </div>

        <div :class="$style.buttonContainer">
          <div
            :class="$style.nextButton"
            @click="$emit('onNext', { aboutYou: form })"
          >
            <b :class="$style.name">Next</b>
          </div>
          <div :class="$style.backButton" @click="$emit('onPrev')">
            <b :class="$style.name">Back</b>
          </div>
        </div>
      </div>
      <div :class="$style.frameChild4" />
    </div>
    <div :class="$style.frameChild5" />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
  },
  components: {
    HiloSelect,
  },
  data() {
    return {
      form: {
        faaNumber: "",
        expirationDate: "",
        faaRegion: "",
        designation: "",
        certifications: "",
        flightHours: "",
        checkrides: "",
        aircraftCheckrides: "",
        travelCheckrides: "",
        localCheckrides: "",
      },
    };
  },
});
</script>

<style module scoped>
.buttonContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.buttonContainer div {
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.buttonContainer div:hover {
  opacity: 0.8;
}

.nextButton {
  background-color: #3c78ff;
}

.backButton {
  background-color: #ccc;
}
.frameGroup {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.uploadBtn {
  width: fit-content;
  align-items: end;
}

.flexGroup {
  display: grid;
  gap: 10px;
}

.spaceBetween {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.formGroup {
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
}

.formGroup p {
  font-size: 16px;
}

.frameContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 25px;
}
</style>
